module.exports = __webpack_public_path__ + "static/media/cheeseburger-biting.ff2a2806.svg";